import { Injectable, inject } from '@angular/core';
import { ModuleConfig } from '@shared-config/moduleConfig';
import { GoogleAnalyticsHelper } from '@shared-helpers/googleAnalyticsHelper';
import { GoogleAnalyticsService } from '@shared-services/google-analytics.service';

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class InitialiseService {

  private moduleConfig = inject(ModuleConfig);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private googleAnalyticsHelper = inject(GoogleAnalyticsHelper);

  constructor() { }

  // Called at application startup e.g. page load
  initialise(): void {
    if (this.moduleConfig?.GoogleAnalyticsFunctionalitySupported) {
      // Check for Google Analytics ClientId
      this.googleAnalyticsService?.checkForClientId();
      document?.addEventListener('click', (event) => {
        this.googleAnalyticsHelper?.handleClickEvent(event);
      });
    }
  }
}
